<div class="flex flex-col gap-6">
  <div class="border-b border-gray-200 pb-3">
    <h2 class="text-lg font-semibold text-gray-900">Order History</h2>
  </div>

  <div class="relative ml-4 border-l-2 border-transparent pb-4 pl-8">
    @for (event of historyEvents(); track $index; let last = $last) {
      <div class="relative mb-10 last:mb-0">
        @if (!last) {
          <div
            class="absolute top-0 bottom-[-40px] left-[-34px] w-0.5"
            [class.bg-green]="event.completed"
            [class.bg-gray-200]="!event.completed"></div>
        }

        <div
          class="absolute top-0 -left-[45px] flex h-6 w-6 items-center justify-center rounded-full border-2 border-white shadow-sm"
          [class.bg-green]="event.completed"
          [class.bg-border-input]="!event.completed">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>

        <div class="flex flex-col gap-1">
          <h3
            class="text-[15px] font-bold tracking-tight"
            [class.text-title]="event.completed"
            [class.text-gray-400]="!event.completed">
            {{ event.statusEn }}
          </h3>

          @if (event.date) {
            <div class="text-[12px] font-medium text-gray-500">
              {{ event.date | date }}
            </div>
          }

          @if (event.user) {
            <div class="text-[12px] text-gray-400 italic">
              {{ event.user }}
            </div>
          }

          @if (event.description) {
            <div class="mt-1 text-[13px] leading-relaxed text-gray-600">
              {{ event.description }}
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
